import { get } from "./client";

export interface VersionInfo {
  version: string;
}

export function getVersion(): Promise<VersionInfo> {
  return get<VersionInfo>("/version");
}
